<template>
  <div class="watch_content">
    <div class="headerNav">
      <van-nav-bar
        :title="videoName"
        left-arrow
        :fixed="true"
        style="background: var(--depYelColor)"
        @click-left="onClickLeft"
      >
        <template #left>
          <i class="iconfont iconjiantou1" style="font-size: 26px"> </i>
        </template>
      </van-nav-bar>
    </div>
    <div class="video_container">
      <!-- 视频播放器主体 -->
      <video
        ref="video"
        class="video_content"
        :style="{ height: height + 'px' || '100%' }"
        disablePictureInPicture
        webkit-playsinline="true"
        x5-playsinline=""
        x5-video-player-type="h5"
        x5-video-player-fullscreen=""
        playsinline
        preload="auto"
        :src="videoUrl"
        @timeupdate="updateProgressBar"
        @click="expandControls"
        @dblclick="playOrPause"
        x-webkit-airplay="allow"
        x5-video-orientation="portrait"
        @ended="onEnded"
        @loadedmetadata="onLoaded"
      ></video>

      <!-- 视频进度条 -->
      <div class="video_progress" v-show="showControls">
        <van-row>
          <van-col span="3" class="video_progress_time">{{
            currentTime
          }}</van-col>
          <van-col span="18">
            <Slider
              v-model="videoProgress"
              @change="onSliderChange($event)"
              @drag-start="onDrag(true)"
              @drag-end="onDrag(false)"
              button-size="10"
              active-color="#fff"
            />
          </van-col>
          <van-col span="3" class="video_progress_time">{{ duration }}</van-col>
        </van-row>
      </div>

      <!-- 暂停/播放按钮 -->
      <div class="icon_play">
        <van-icon
          name="pause-circle-o"
          color="white"
          v-show="iconPauseShow && showControls"
          size="60"
          @click.prevent="pauseVideo"
        />
        <van-icon
          name="play-circle-o"
          color="white"
          v-show="iconPlayShow && showControls"
          size="60"
          @click.prevent="playVideo"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Slider } from "vant";
import { getVideoOrder } from "api/onLine";
export default {
  components: { Slider },
  data() {
    return {
      videoOrderId: -1,
      videoName: "",
      videoUrl: "",
      playing: false,
      showControls: true,
      iconPlayShow: true,
      iconPauseShow: false,
      height: null,
      videoProgress: 0,
      currentTime: "00:00",
      duration: "00:00",
      timedEventId: -1,
    };
  },
  created() {
    var videoOrderId = this.$route.query.videoOrderId;
    if (videoOrderId == undefined) {
      this.videoOrderId = -1;
    } else {
      this.videoOrderId = videoOrderId;
    }
    this.loadVideo();
  },
  mounted() {
    // 计算视频组件高度
    if (window.innerHeight) {
      this.height = window.innerHeight - 46;
    }
  },
  methods: {
    // 返回订单列表
    onClickLeft() {
      this.$push({
        path: "/orders?type=-1",
      });
    },
    // 加载视频信息
    loadVideo() {
      getVideoOrder(this.videoOrderId, -1).then((res) => {
        if (res.status == 200 && res.data) {
          this.arryList = res.data;
          this.videoName = res.data.videoName;
          this.videoUrl = `http://${res.data.videoUrl}`;
        } else {
          this.$error("获取视频失败，请稍后重试");
        }
      });
    },
    // 显示/隐藏视频控制组件
    expandControls() {
      this.showControls = !this.showControls;
      if (this.showControls && this.playing) {
        this.timedEventId = this.hideControls();
      } else {
        this.clearHideEvent();
      }
    },
    // 一段时间无操作后隐藏视频控制组件
    hideControls() {
      return setTimeout(() => {
        if (this.timedEventId != -1) {
          this.showControls = false;
          this.timedEventId = -1;
        }
      }, 3000);
    },
    // 清除隐藏控件延时任务
    clearHideEvent() {
      if (this.timedEventId != -1) {
        clearTimeout(this.timedEventId);
        this.timedEventId = -1;
      }
    },
    // 播放视频
    playVideo() {
      const videoEl = this.$el.querySelector("video");
      videoEl.play();
      this.playing = true;
      this.iconPlayShow = false;
      this.iconPauseShow = true;
      this.timedEventId = this.hideControls();
    },
    // 暂停视频
    pauseVideo() {
      this.clearHideEvent();
      const videoEl = this.$el.querySelector("video");
      videoEl.pause();
      this.playing = false;
      this.iconPlayShow = true;
      this.iconPauseShow = false;
    },
    // 暂停/播放视频
    playOrPause() {
      if (this.playing) {
        this.pauseVideo();
      } else {
        this.playVideo();
      }
    },
    // 视频播放完毕
    onEnded() {
      this.clearHideEvent();
      this.videoProgress = 100;
      this.currentTime = this.duration;
      this.playing = false;
      this.showControls = true;
      this.iconPauseShow = false;
      this.iconPlayShow = true;
    },
    // 视频加载完毕
    onLoaded() {
      const videoEl = this.$el.querySelector("video");
      this.duration = this.timeFormatter(videoEl.duration);
    },
    // 改变进度条进度
    onSliderChange(e) {
      this.clearHideEvent();
      const videoEl = this.$el.querySelector("video");
      videoEl.currentTime = (e / 100) * videoEl.duration;
      if (this.playing) {
        this.timedEventId = this.hideControls();
      }
    },
    // 进度条拖拽事件，拖拽时暂停视频播放
    onDrag(drag) {
      this.clearHideEvent();
      if (this.playing) {
        const videoEl = this.$el.querySelector("video");
        if (drag) {
          videoEl.pause();
        } else {
          videoEl.play();
          this.timedEventId = this.hideControls();
        }
      }
    },
    // 根据当前视频时间更新进度条
    updateProgressBar() {
      const videoEl = this.$el.querySelector("video");
      this.videoProgress = (videoEl.currentTime / videoEl.duration) * 100;
      this.currentTime = this.timeFormatter(videoEl.currentTime);
      this.lastTime = videoEl.currentTime;
    },
    // 时间格式化  秒-->MM:SS
    timeFormatter(time) {
      const minutes = Math.floor(time / 60);
      const seconds = time % 60;
      return (
        minutes.toFixed(0).padStart(2, "0") +
        ":" +
        seconds.toFixed(0).padStart(2, "0")
      );
    },
  },
};
</script>

<style scoped lang="less">
.watch_content {
  background: black;
}
.headerNav {
  height: 46px;
  /deep/.van-nav-bar {
    color: #fff;
    .van-icon,
    .van-nav-bar__text,
    .van-nav-bar__title,
    a {
      color: inherit;
      vertical-align: middle;
    }
    .van-nav-bar__title {
      font-size: 18px;
    }
    .van-icon,
    .iconfont {
      font-size: 24px;
      vertical-align: middle;
    }
    .iconjiantou1 {
      font-size: 26px;
    }
  }
  .van-nav-bar::after {
    content: "";
    border: none;
  }
}
.video_container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.video_content {
  width: 100%;
  object-fit: contain;
}
.video_progress {
  position: absolute;
  width: 100%;
  bottom: 3%;
  z-index: 10000;
  .video_progress_time {
    font-size: 10px;
    text-align: center;
    color: white;
  }
}
.van-slider {
  background-color: gray;
  height: 5px;
  margin-top: 3px;
}
.icon_play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000;
  opacity: 0.6;
}
</style>
